import { render, staticRenderFns } from "./TrailDetails.vue?vue&type=template&id=3e55c0c4"
import script from "./TrailDetails.vue?vue&type=script&lang=js"
export * from "./TrailDetails.vue?vue&type=script&lang=js"
import style0 from "./TrailDetails.vue?vue&type=style&index=0&id=3e55c0c4&prod&module=true&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports